/**
 * React Query hooks for fix session data.
 */

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  fetchFixSession,
  updateFixDecisions,
  type FixDecision,
  type FixSession,
} from "../api/fix";

export function useFixSession(sessionId: string) {
  return useQuery<FixSession>({
    queryKey: ["fixSession", sessionId],
    queryFn: () => fetchFixSession(sessionId),
    refetchInterval: (query) => {
      const data = query.state.data;
      if (data?.status === "complete") return false;
      return 3_000;
    },
  });
}

export function useUpdateFixDecisions(sessionId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      decisions,
      status,
    }: {
      decisions: FixDecision[];
      status: "in_progress" | "complete";
    }) => updateFixDecisions(sessionId, decisions, status),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["fixSession", sessionId] });
    },
  });
}
